/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableOpacity, Image } from 'react-native'
import TextComponent from './TextComponent'
import styles from './Styles/ViewAllPostsComponentStyle'
import { Images } from '../Themes'
import I18n from "i18n-js"

export default class ViewAllPostsComponent extends Component {


  render() {
    return (
      <View style={styles.container}>
        <TouchableOpacity onPress={this.props.onPress}>
          <View style={styles.content}>
            <Image source={Images.add} style={styles.image} />
            <TextComponent style={styles.text} text={I18n.t('explora.viewAllPost')} />
          </View>
        </TouchableOpacity>
      </View>
    )
  }
}
